import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { logout } from "../features/auth/authSlice"; // adjust this path

const useAuthEffect = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const token = localStorage.getItem("clientToken");

        // Match public routes that start with these prefixes
        const publicPrefixes = ["/signin", "/resetpassword", "/help", "/promo", "/programs"];
        const isPublicRoute = publicPrefixes.some(prefix =>
            location.pathname.startsWith(prefix)
        );

        if (!token && !isPublicRoute) {
            dispatch(logout()).then(() => {
                history.push("/signin");
            });
        }
    }, [location.pathname, dispatch, history]);
};

export default useAuthEffect;
